import React from 'react';
import './ErrorPage.css';

const ErrorPage = () => {
    return (
    <div id="ErrorPage" className='ErrorPage'>
        <h1 className='ErrorPage'>Page not found!</h1>
    </div>
    )};

export default ErrorPage